import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import * as bodyScrollLock from 'body-scroll-lock';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnDestroy {
  private isSideNavOpen: boolean;

  @Output() handleClose = new EventEmitter<void>();

  @ViewChild('sideNavWrapper', { static: false })
  sideNavWrapperElement;

  @Input() set isOpen(currentSideNavState: boolean) {
    this.isSideNavOpen = currentSideNavState;

    if (this.isSideNavOpen === true) {
      this.disableBodyScroll();
      return;
    }

    this.enableBodyScroll();
  }

  get isOpen(): boolean {
    return this.isSideNavOpen;
  }

  ngOnDestroy() {
    this.closeSideNav();
  }

  public closeSideNav() {
    if (this.isSideNavOpen) {
      this.handleClose.emit();
      this.enableBodyScroll();
    }
  }

  disableBodyScroll() {
    bodyScrollLock.disableBodyScroll(this.sideNavWrapperElement);
  }

  enableBodyScroll() {
    bodyScrollLock.enableBodyScroll(this.sideNavWrapperElement);
  }
}
